import {useRef} from "react";
import {Box, Stack, Typography} from "@mui/material";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import VncDisplay from "react-vnc-display";
import styles from "../style.module.scss"

export default function SunstoreConsole({name, url}: any) {
    const ref = useRef<any>(null);

    const onSendCtrlAltDel = () => {
        ref.current?.rfb.sendCtrlAltDel();
    };

    // const onClipboardPasteFrom = (text: string) => {
    //     ref.current?.rfb.clipboardPasteFrom(text)
    // };

    return (
        <>
            <Stack justifyContent="start" alignItems="center" sx={{
                bgcolor: 'black',
                minHeight: '100vh',
                canvas: {
                    width: '1000px ! important',
                    height: '755px ! important'
                }
            }}>
                <Box sx={{p: '12px', width: '100%', height: 82}}>
                    <Typography
                        fontSize={15}
                        fontWeight={600}
                        whiteSpace="nowrap"
                        color="white"
                        fontFamily="Arial, sans-serif"
                        lineHeight="normal"
                    >
                        {name}
                    </Typography>
                    <button onClick={() => onSendCtrlAltDel()} className={styles.Button}>
                        Send Ctrl+Alt+Delete
                    </button>
                </Box>
                <VncDisplay ref={ref} url={url} compressionLevel={5} scaleViewport resizeSession/>
            </Stack>
        </>
    )
}